var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "modal", staticClass: "modal fade", attrs: { role: "dialog" } },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-scrollable",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.$t("chartwizardTemplates")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _vm.templates &&
              _vm.templates.templates &&
              _vm.templates.templates.length
                ? _c(
                    "ul",
                    { staticClass: "list-group" },
                    _vm._l(_vm.templates.templates, function(template) {
                      return _c(
                        "li",
                        {
                          key: template,
                          staticClass: "list-group-item c-pointer",
                          on: {
                            click: function($event) {
                              _vm.$emit("selected", template)
                              _vm.closeModal()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(template.name) +
                              "\n                        "
                          ),
                          _c("div", { staticClass: "float-right" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-danger",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.$emit("deleted", template)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-dumpster" })]
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _c("div", [_vm._v(_vm._s(_vm.chartwizardNoTemplates))])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }